import React from 'react';
import ReactDOM from 'react-dom';
import { Link } from 'react-router';
import axios from 'axios';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Auth from '../../modules/Auth.js';
import {setCurrentUser} from '../../actions/Login.js';
import General from '../../modules/General';
import Raven from 'raven-js';
import LoadingSmall from '../../components/LoadingSmall';

class Reset extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error:false,
            isLoading:true,
            user:false,
        }
        this.reset = this.reset.bind(this);
    }

    componentWillMount() {
        if(this.props.auth.isAuthenticated) {
            this.props.router.push(General.Link('/dashboard'));
        }
        this.addBodyClass(true);
        axios.get('/users/getReset?reset='+this.props.router.params.token).then(res => {
            this.setState({isLoading:false,user:res.data});
        }).catch(err => {
            this.setState({isLoading:false,error:true});
        });

    }

    componentWillUnmount() {
        this.addBodyClass(false);
    }

    addBodyClass(add) {
        if(add) {
            document.body.classList.add('page-login-v3');
            document.body.classList.add('layout-full');

        }else{
            document.body.classList.remove('page-login-v3');
            document.body.classList.remove('layout-full');

        }
    }

    reset(e) {
        e.stopPropagation();

        axios.post('/users/reset',{ token:this.props.router.params.token,password:this.refs.password.value})
            .then((res) => {
                Auth.authenticate(res.data.token,res.data.account_id);

                if(this.props.location.query.next) {
                    this.props.router.push(this.props.location.query.next);
                }else{
                    this.props.router.push(res.data.account_id+'/dashboard');
                }
            })
            .catch((res) => {
                if(typeof res.response == 'undefined') {
                    Raven.captureException(res)
                    throw res;
                    return;
                }
                switch(res.response.data.code) {
                    case 'AUTH_FAIL':

                        break;

                    case 'TOKEN_EXPIRED':

                        break;

                    case 'TOKEN_INVALID':

                        break;

                    case 'GENERIC_ERROR':

                        break;

                    default:

                        break;
                }
            });
    }

    render() {
        return (
            <div className="page vertical-align text-xs-center" data-animsition-in="fade-in" data-animsition-out="fade-out">>
                <div className="page-content vertical-align-middle animation-slide-top animation-duration-1">
                    <div className="panel">
                        <div className="panel-body">
                            <div className="brand">
                                <img className="brand-img" style={{width:'100%'}} src="/assets/images/logo.png" alt="..." />
                            </div>
                            <form method="post" action="#">
                                {
                                    this.state.isLoading ? <LoadingSmall />:
                                        this.state.error ? 'Invalid reset link':
                                            <div>
                                                <div className="form-group form-material floating" data-plugin="formMaterial">
                                                    <input ref="password" type="password" className="form-control" name="password" />
                                                    <label className="floating-label">New password</label>
                                                </div>
                                                <button type="button" className="btn btn-primary btn-block btn-lg m-t-40" onClick={(e) =>  this.reset(e) }>Reset password</button>
                                            </div>
                                }

                            </form>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        auth:state.auth
    }
}

const mapDispatchToProps = (dispatch) => {
    return bindActionCreators({setCurrentUser},dispatch)
}
Reset = connect(mapStateToProps,mapDispatchToProps)(Reset);

export default Reset;


// WEBPACK FOOTER //
// ./containers/login/reset.js